import { Component } from "react"
import PropTypes from "prop-types"

import { StatusRow } from "./table_components"
import PopulatorValue from "./populator_value"
import { findFieldTypeDescriptionByID } from "partners/components/shared/stencilable_field_types"

class QueryField extends Component {
  renderAttributes() {
    const { queryField, feedbackItems = {}, diffStyle, pathObjs } = this.props
    let attributes = [
      {
        key: `query-field-item-name-${queryField.id}`,
        name: "Label",
        value: queryField.name,
        required: true,
        fieldName: "name",
      },
      {
        key: `query-field-item-helper-text-${queryField.id}`,
        name: "Optional helper text",
        value: queryField.helper_text,
        fieldName: "helper_text",
      },
      {
        key: `query-field-item-slug-${queryField.id}`,
        name: "Key name",
        value: queryField.slug,
        required: true,
        fieldName: "slug",
      },
      {
        key: `query-field-item-required-${queryField.id}`,
        name: "Required?",
        value: queryField.required,
        transform: value => (value ? "Yes" : "No"),
        fieldName: "required",
      },
      {
        key: `query-field-item-field-type-${queryField.id}`,
        name: "Field Type",
        value: queryField.query_field_type,
        transform: findFieldTypeDescriptionByID,
        fieldName: "query_field_type",
      },
    ]

    if (queryField.query_field_type === 14 || queryField.query_field_type === 19) {
      const diffs = this.props.changes.filter(
        diff => diff.path[4] === "populator_values"
      )
      const originalChannel = this.props.originalChannel
      attributes = attributes.concat([
        {
          key: "query-field-item-populator-values",
          name: "Dropdown Options",
          value: queryField.populator_values,
          required: true,
          transform: value => (
            <PopulatorValue
              diffStyle={diffStyle}
              originalChannel={originalChannel}
              values={value}
              changes={diffs}
              parent="queries"
              collection="query_fields"
            />
          ),
          fieldName: "populator_values",
        },
      ])
    }

    const submenuIcons = JSON.parse(window.sessionStorage.submenuIcons)
    return attributes.map(item => {
      item.feedback = feedbackItems[item.fieldName]
      item.pathObjs = [...this.props.pathObjs, queryField.id, item.fieldName]
      item.diff = this.props.changes.find(
        diff =>
          diff.data &&
          diff.data.property === item.fieldName &&
          diff.path.length === 4
      )
      if (item.feedback && !submenuIcons.queriesFeedback) {
        this.props.setSessionFeedback("queries", submenuIcons)
      }
      return this.props.tableRow(item)
    })
  }

  render() {
    return (
      <table className="subtable">
        <tbody>
          {this.props.diffStyle !== "none" && (
            <StatusRow status={this.props.status} />
          )}
          {this.renderAttributes()}
        </tbody>
      </table>
    )
  }
}

QueryField.propTypes = {
  diffStyle: PropTypes.string.isRequired,
  originalChannel: PropTypes.object,
  status: PropTypes.oneOf(["new", "deleted", "updated", "stale"]).isRequired,
  pathObjs: PropTypes.array.isRequired,
  queryField: PropTypes.object.isRequired,
  changes: PropTypes.array.isRequired,
  feedbackItems: PropTypes.object,
  tableRow: PropTypes.func.isRequired, // Should be imported
  setSessionFeedback: PropTypes.func.isRequired,
}

export default QueryField
